module.exports = __webpack_public_path__ + "img/add.9dd1f3f3.svg";